<template>
  <ul>
    <component
      :is="resolveNavItemComponent(item)"
      v-for="item in visibleItems"
      :key="item.header || item.title"
      :item="item"
    />
  </ul>
</template>

<script>
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { provide, ref } from '@vue/composition-api'
import { isItemVisibleForRole } from '@/navigation/roleVisibility'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'
import VerticalNavMenuGroup from '../vertical-nav-menu-group/VerticalNavMenuGroup.vue'

export default {
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    /*
     * `v-permission` só sabe olhar permissão, e há item que precisa sumir por
     * papel (o Mural para o influencer). Filtrar aqui — e não no arquivo de
     * navegação — porque o módulo é avaliado uma única vez, no import, e o
     * login não recarrega a página: quem entrasse depois de um logout veria o
     * menu do usuário anterior.
     */
    visibleItems() {
      return this.items.filter(isItemVisibleForRole)
    },
  },
  setup() {
    provide('openGroups', ref([]))

    return {
      resolveNavItemComponent,
    }
  },
}
</script>
